import React from 'react';
import { TimeRange } from 'utils/time';
import DatePickerFooterView from './DatePickerFooter.view';

type Props = {
  range: TimeRange;
  overLimit?: number | null;
  setRange: (range: TimeRange) => void;
};

const DatePickerFooter = (props: React.PropsWithChildren<Props>): JSX.Element => {
  const onChangeFrom = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value) {
      props.setRange({
        from: value,
        to: props.range.to,
      });
    }
  };

  const onChangeTo = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value) {
      props.setRange({
        from: props.range.from,
        to: value,
      });
    }
  };

  return <DatePickerFooterView overLimit={props.overLimit} range={props.range} onChangeFrom={onChangeFrom} onChangeTo={onChangeTo}></DatePickerFooterView>;
};

DatePickerFooter.displayName = 'DatePickerFooter';

export default DatePickerFooter;
